/* eslint-disable indent */
import CreatableSelect from "react-select/creatable";
import styled from "styled-components";

import { Option } from "types";
import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const SelectWrapper = styled.div`
    flex-grow: 2;
    min-width: 7rem;
    ${device.md} {
        min-width: 10rem;
    }
`;

export const CreatableReactSelect = styled(CreatableSelect).attrs(() => ({
    styles: {
        control: (base) => ({
            ...base,
            backgroundColor: colourScheme.primary,
            border: `2px solid ${colourScheme.white}`,
            borderRadius: "0.5rem",
            cursor: "pointer",
            color: colourScheme.white,
            "&:hover": {
                borderColor: colourScheme.white,
            },
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: colourScheme.primary,
            color: colourScheme.white,
        }),
        option: (base, { isFocused, isSelected, isDisabled, data }) => {
            const optionData = data as Option;
            const isCreateOption = optionData.__isNew__;

            return {
                ...base,
                backgroundColor: isDisabled
                    ? colourScheme.primary
                    : isSelected
                    ? colourScheme.secondary
                    : isFocused
                    ? colourScheme.secondary
                    : isCreateOption
                    ? colourScheme.primaryDark // Special background color for "Create your own..."
                    : colourScheme.primaryDark,
                color: isDisabled
                    ? colourScheme.grey
                    : isCreateOption
                    ? colourScheme.success // Special text color for "Create your own..."
                    : colourScheme.white,
                cursor: isDisabled ? "not-allowed" : "pointer",
            };
        },
        singleValue: (base) => ({
            ...base,
            color: colourScheme.white,
        }),
        input: (base) => ({
            ...base,
            color: colourScheme.white,
        }),
        placeholder: (base) => ({
            ...base,
            color: colourScheme.white,
        }),
        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: colourScheme.primary,
        }),
        dropdownIndicator: (base, { isFocused }) => ({
            ...base,
            color: isFocused ? colourScheme.secondary : colourScheme.white,
            "&:hover": {
                color: colourScheme.secondary,
            },
        }),
        clearIndicator: (base) => ({
            ...base,
            cursor: "pointer",
            color: colourScheme.white,
            "&:hover": {
                color: colourScheme.secondary,
            },
        }),
        groupHeading: (base) => ({
            ...base,
            backgroundColor: colourScheme.primary,
            color: colourScheme.success,
            fontSize: "1rem",
            fontWeight: "bold",
            padding: "0.5rem",
        }),
        group: (base) => ({
            ...base,
            padding: 0,
        }),
    },
}))``;
